import { getPresenceCloudConfig } from '../config/cloudConfig';

export function getPresenceResource(): string {
    return getPresenceCloudConfig().presenceResource;
}

export const PRESENCE_RETRY_COUNT = 1;
